
<div class=" loading" *ngIf="loader">Loading&#8230;
</div>
<router-outlet></router-outlet>

<!--custom-footer class="row col-12 p-0 m-0 alignFooterToBtm" ></custom-footer-->
